import React, { useEffect, useCallback, useState } from 'react'
import Label from '../../home/ad/label'
import { get } from 'lodash'
import fetch from 'lib/decorated-fetch'
import { useAdStat } from 'Components/ad'
import applyHttpsImage from 'lib/apply-https-img'
import { ICornerDialogAd } from './interface'

const TongLan: React.FC<{}> = () => {
  const [info, setInfo] = useState<ICornerDialogAd>()

  const getAds = useCallback(() => {
    return fetch(`/motor/ad/m/pc/model_library_top_banner`, {
      credentials: 'include',
    })
  }, [])
  useEffect(() => {
    getAds()
      .then(res => {
        setInfo(get(res, 'data.model_library_top_banner_ad', {}))
      })
      .catch(e => {
        // no-op
      })
  }, [])

  if (!info || Object.keys(info).length === 0) {
    return null
  }
  return <>{info.id_str && <TongLanImg data={info} />}</>
}

function TongLanImg({ data }: { data: ICornerDialogAd }) {
  const { ref, handleClick } = useAdStat(
    {
      send: 'ad_send_garage_top_banner',
      show: 'ad_show_garage_top_banner',
      click: 'ad_click_garage_top_banner',
    },
    data
  )
  return (
    <div
      className="ad_container"
      ref={ref}
      onClick={() => {
        handleClick()
        setTimeout(() => {
          window.open(data.web_url, '_blank')
        }, 50)
      }}
    >
      {get(data, 'image.url', '') && (
        <img
          className="banner_img"
          src={applyHttpsImage(get(data, 'image.url', ''))}
        />
      )}
      {data.label && <Label text={data.label} />}
      <style jsx>
        {`
          .ad_container {
            width: 1196px;
            height: 90px;
            margin: 16px auto -6px;
            background: #f2f2f2;
            position: relative;
            border-radius: 2px;
            overflow: hidden;
          }
          .banner_img {
            width: 100%;
            height: 100%;
          }
        `}
      </style>
    </div>
  )
}

export default TongLan
